<template>
  <div class="page-main">
    <div v-if="loginLoading" class="loading-mask">
      <div class="chase"></div>
      <div class="loading-text">正在登录，请稍后...</div>
    </div>
    <div class="login_container">
      <div class="login_box">
        <el-row>
          <el-col :span="16" :offset="6">
            <img class="login_logo" src="../assets/image/hehai.png" />
            <el-form
              v-if="formView"
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
            >
              <!-- <el-form-item prop="mobile">
                <el-input
                  type="text"
                  v-model="ruleForm.mobile"
                  placeholder="请输入账户"
                  autocomplete="off"
                ></el-input>
              </el-form-item> -->
              <el-form-item prop="username">
                <el-input
                  type="text"
                  v-model="ruleForm.username"
                  autocomplete="off"
                  placeholder="请输入账户"
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  type="password"
                  v-model="ruleForm.password"
                  placeholder="请输入密码"
                  autocomplete="off"
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="validateCode" class="input_ver">
                <el-col :span="10">
                  <el-input
                    v-model="ruleForm.validateCode"
                    placeholder="请输入验证码"
                  ></el-input>
                </el-col>
                <el-col :span="10" :offset="4">
                  <!-- <el-button type="primary" @click="getVerifycode" name=""
                    >获取验证码</el-button
                  > -->
                  <div @click="getVerifyGrccode">
                    <img :src="qrcodeSrc" style="width: 100%;height: 100%" />
                  </div>
                </el-col>
              </el-form-item>
              <el-form-item class="login-btn-container">
                <el-button
                  class="loginBtn"
                  type="primary"
                  :loading="loginLoading"
                  @click.native.prevent="goLogin('ruleForm')"
                  @keyup.enter.native="goLogin('ruleForm')"
                  >登 录
                </el-button>

                <el-button
                  type="text"
                  class="switch-qrcodeBtn"
                  icon="el-icon-s-grid"
                  @click="showQrcode"
                ></el-button>
              </el-form-item>
            </el-form>
            <div class="code" id="qrcode" ref="qrcode" v-if="!formView"></div>
            <el-row style="text-align: center">
              <el-col :span="12">
                <el-button
                  type="text"
                  style="color: #fff"
                  v-if="!formView"
                  @click="formView = !formView"
                  >账号登录</el-button
                >
                <!--                <el-button type="text" style="color: #fff">注册账户</el-button>-->
              </el-col>
              <el-col :span="formView ? 24 : 12" align="right">
                <el-button
                  type="text"
                  style="color: #fff"
                  @click="forgetPassword"
                  >忘记密码</el-button
                >
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <div class="qrcode-box">
        <div>
          <!-- <div class="download" @click="downloadApp"><i class="iconfont icon-anzhuo"
              style="font-weight: 600;font-size: 20px;"></i>&nbsp;&nbsp;&nbsp;Download
            APP</div> -->
          <!--          <div class="code-item">-->
          <!--            <div><img class="" src="../assets/image/core_code.jpg" /></div>-->
          <!--            <div>公众号二维码</div>-->
          <!--          </div>-->
          <!--          <div class="code-item">-->
          <!--            <div><img class="" src="../assets/image/core_code.jpg" /></div>-->
          <!--            <div>APP二维码</div>-->
          <!--          </div>-->
        </div>
      </div>
      <div class="footer-bottom">
        <p>
          Copyright © 2005-2025 河海大学高性能计算平台 版权所有
        </p>
        <!-- 浪潮项目备案号 -->
        <!-- <p>浙ICP备05074421号 浙公网安备33010602010295</p> -->
      </div>
    </div>
  </div>
</template>
<script>
// import { nanoid } from "nanoid";
// import { mapMutations } from "vuex";
import { lib } from "../assets/js/lib";
import { v1 as uuidv1 } from "uuid";
import fetch from "../api/fetch";
import QRCode from "qrcodejs2";
import { aes } from "../assets/js/crypto";
export default {
  components: {
    // wxlogin
    QRCode
  },
  name: "Login",
  data() {
    var isvalidPhone = (rule, value, callback) => {
      const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
      if (!value) {
        return callback(new Error(this.$t("mobile")));
      } else if (!reg.test(value)) {
        return callback(new Error(this.$t("mobileCheck")));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        username: "",
        password: "",
        //mobile: "",
        validateCode: ""
      },
      loginLoading: false,
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            min: 5,
            max: 16,
            message: "用户名由5-16位的英文字母数字下划线组成",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 16,
            message: "密码由6-16位的字母数字下划线组成",
            trigger: "blur"
          }
        ],
        //mobile: [{ validator: isvalidPhone, trigger: "blur" }],
        validateCode: [
          {
            required: true,
            message: "验证码错误",
            trigger: "blur"
          }
        ]
      },
      formView: true,
      uuidLogin: undefined,
      // qrcodeSrc: "/sso/captcha?r=" + new Date().valueOf()
      qrcodeSrc: ""
    };
  },
  destroyed() {
    window.clearInterval(this.timer);
  },
  methods: {
    checkLoginPolling() {
      this.timer = window.setInterval(() => {
        const current = this;
        this.http
          .post("/weixin-server/wechat/auth/wxLoginForWebPolling", {
            uuidLogin: this.uuidLogin
          })
          .then(res => {
            if (!res.data.code || res.data.code === "1000") {
              return false;
            }
            let data = res.data;
            // console.log(data.toString())
            lib.cookie.set("Hpc-Platform-Token", data.data);
            this.loginSuccess(data.data, function(res) {
              //页面跳转
              let avatar = res.data.avatar
                ? res.data.avatar
                : "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png";
              current.$store.commit("updateUser", {
                name: res.data.name,
                username: res.data.username,
                userProperty: res.data.userProperty,
                avatar: avatar,
                balance: res.data.balance
              });
              const clusters = res.data.clusters;
              if (clusters) {
                current.$store.commit("updateClusters", clusters);
                current.$store.commit("updatecurrentCluster", {
                  clusterName: clusters[0].clusterName
                });
                lib.cookie.set("HEAD-CLUSTER-NAME", clusters[0].clusterName);
              }
              lib.sessionStorage.set("name", res.data.name);
              lib.sessionStorage.set("avatar", avatar);
              lib.sessionStorage.set("username", res.data.username);
              lib.sessionStorage.set("userProperty", res.data.userProperty);
              lib.sessionStorage.set("balance", res.data.balance);
              current.$router.replace("/");
              window.store = current.$store;
              clearInterval(this.timer);
            });
          });
      }, 1500);
    },
    qrcode() {
      let qrcode = new QRCode("qrcode", {
        width: 150, // 设置宽度
        height: 150, // 设置高度
        text:
          "https://test-hpc.bcores.com/weixin-server/wechat/auth/wxLoginForWeb?state=" +
          this.uuidLogin
      });
    },
    getCaptchaUrl() {
      const uuid = uuidv1();
      sessionStorage.setItem("captchaHeaderKey", uuid);
      // this.qrcodeSrc = "/sso/captcha?r=" + new Date().valueOf();
      // this.qrcodeSrc = "/sso-server/captcha?r=" + new Date().getTime();
      // 本地走/sso,生产走/sso-server
      this.http
        .get("/sso-server/captcha?r=" + new Date().getTime(), {
          responseType: "blob",
          params: { uuid: uuid }
        })
        .then(response => {
          if (response && response.data) {
            // 释放之前的对象URL
            if (this.qrcodeSrc) {
              URL.revokeObjectURL(this.qrcodeSrc);
            }

            // 创建新的对象URL
            const imageUrl = URL.createObjectURL(response.data);
            this.qrcodeSrc = imageUrl;
          } else {
            console.error("获取验证码失败:", response);
            this.qrcodeSrc = "";
          }
        });
    },
    getVerifyGrccode() {
      this.ruleForm.validateCode = "";
      if (this.qrcodeSrc) {
        URL.revokeObjectURL(this.qrcodeSrc);
      }
      this.getCaptchaUrl();
    },
    goLogin(formName) {
      //点击登录
      this.$refs[formName].validate(valid => {
        if (valid) {
          const uuid = sessionStorage.getItem("captchaHeaderKey");
          const encryptedUsername = aes.en(this.ruleForm.username);
          const encryptedPassword = aes.en(this.ruleForm.password);
          // const requestData = {
          //   ...this.ruleForm,
          //   username: encryptedUsername,
          //   password: encryptedPassword,
          //   uuid: uuid // 将 uuid 添加到请求数据中
          // };
          // 将参数拼接到URL中
          const params = new URLSearchParams({
            ...this.ruleForm,
            username: encryptedUsername,
            password: encryptedPassword,
            uuid: uuid
          }).toString();
          const url = `/sso/security_check?${params}`;
          this.loginLoading = true;
          this.http
            .post(
              url,
              {},
              {
                headers: {
                  Authorization: "Basic U2FtcGxlQ2xpZW50SWQ6dGdiLjI1OA==",
                  "api-login": lib.config.apiLogin,
                  loginFlag: true
                }
              }
            )
            .then(res => {
              // console.log(res);
              if (res.data.status === -1) {
                this.$message.error(res.data.message);
                this.getVerifyGrccode();
                return false;
              }
              let data = res.data;
              lib.cookie.set("Hpc-Platform-Token", data.data.access_token);
              const current = this;
              this.loginSuccess(data.data, function(res) {
                //页面跳转
                let avatar = res.data.avatar
                  ? res.data.avatar
                  : "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png";
                current.$store.commit("updateUser", {
                  name: res.data.name,
                  username: res.data.username,
                  userProperty: res.data.userProperty,
                  avatar: avatar,
                  balance: res.data.balance
                });
                const clusters = res.data.clusters;
                if (clusters) {
                  current.$store.commit("updateClusters", clusters);
                  current.$store.commit("updatecurrentCluster", {
                    clusterName: clusters[0].clusterName
                  });
                  lib.cookie.set("HEAD-CLUSTER-NAME", clusters[0].clusterName);
                }
                lib.sessionStorage.set("name", res.data.name);
                lib.sessionStorage.set("avatar", avatar);
                lib.sessionStorage.set("username", res.data.username);
                lib.sessionStorage.set("userProperty", res.data.userProperty);
                lib.sessionStorage.set("balance", res.data.balance);
                current.$router.replace("/");
                window.store = current.$store;
              });
            })
            .finally(() => {
              this.loginLoading = false;
            });
        } else {
          this.getVerifyGrccode();
          return false;
        }
      });
    },
    handleLoginSuccess(data) {
      const current = this;
      this.loginSuccess(data || {}, function(res) {
        // 页面跳转
        let avatar = res.data.avatar
          ? res.data.avatar
          : "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png";
        current.$store.commit("updateUser", {
          name: res.data.name,
          username: res.data.username,
          userProperty: res.data.userProperty,
          avatar: avatar,
          balance: res.data.balance
        });
        const clusters = res.data.clusters;
        if (clusters) {
          current.$store.commit("updateClusters", clusters);
          current.$store.commit("updatecurrentCluster", {
            clusterName: clusters[0].clusterName
          });
          lib.cookie.set("HEAD-CLUSTER-NAME", clusters[0].clusterName);
        }
        lib.sessionStorage.set("name", res.data.name);
        lib.sessionStorage.set("avatar", avatar);
        lib.sessionStorage.set("username", res.data.username);
        lib.sessionStorage.set("userProperty", res.data.userProperty);
        lib.sessionStorage.set("balance", res.data.balance);
        current.$router.replace("/");
        window.store = current.$store;
      });
    },
    loginSuccess(data, callback) {
      var stores = this.$store;
      //拉取菜单列表
      this.http.get("/client/user/menus", {}).then(res => {
        let menus = [];
        menus.push({
          id: "-1",
          name: "首页",
          clientPath: "/index"
        });
        menus = menus.concat(res.data);
        // this.$router.addRouter("Home", (route: RouteConfig));
        this.$store.commit("updateMenus", menus);
        let menusString = JSON.stringify(menus);
        lib.sessionStorage.set("menus", menusString);
        this.http.get("/client/user/summary-info", {}).then(res => {
          callback(res);
        });
      });
    },
    getVerifycode() {
      var mobile = this.ruleForm.mobile;
      if (!mobile) {
        this.$refs.ruleForm.validateField("mobile");
      } else {
        this.getMsg(mobile);
      }
    },
    getMsg(mobile) {
      // console.log(mobile); //通过手机号发送短信验证
    },
    forgetPassword() {
      this.$router.push({ path: "/forget-password" });
    },
    showQrcode() {
      this.checkLoginPolling();
      this.formView = false;
      this.$nextTick(function() {
        this.qrcode();
      });
    },
    downloadApp() {
      window.location.href =
        "https://physicshpc.zju.edu.cn/download-file/hpc.apk";
    }
  },
  created() {
    this.getCaptchaUrl();
    const token = lib.cookie.get("Hpc-Platform-Token");
    if (token) {
      this.handleLoginSuccess();
      return;
    }
    this.uuidLogin = uuidv1();
    let _that = this;
    lib.errCatch = function(data) {
      _that.$message.error(data.message);
    };
    document.onkeydown = function(e) {
      let key = window.event.keyCode;
      if (key === 13) {
        _that.goLogin("ruleForm");
      }
    };
    //微信扫码登陆重定向
    if (this.$route.query.code) {
      this.http.post("/wxLogin", { code: this.$route.query.code }).then(res => {
        // console.log(res)
        if (res.code != 1) {
          this.$message.error("登录失败");
        }
        this.loginSuccess(res.data);
        this.setToken(res.data.Token);
        this.$router.replace("/");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-main {
  flex-grow: 1;
  //background-color: #e9eef3;
}

.login_container {
  background: url("../assets/image/login-bg-1.png") no-repeat;
  background-size: 100% 100%;
  height: 100%;
}

.login_box {
  width: 450px;
  height: 430px;
  background: rgba(200, 200, 200, 0.2);
  border-radius: 3px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);

  & /deep/ .el-input__inner {
    border: none;
    border-bottom: 1px solid #fff;
    background: none;
    border-radius: 0;
    color: #fff;
  }
}

.loginBtn {
  width: 100%;
}

.login_logo {
  width: 100%;
  margin: 30px 0 10px 0;
}

.login-btn-container {
  position: relative;
}

.switch-qrcodeBtn {
  position: absolute;
  right: -3px;
  bottom: -1px;
  z-index: 99;
  color: #000;
  height: 15px;
}

.qrcode_img {
  width: 100%;
}

.footer-bottom {
  overflow: hidden;
  width: 100%;
  height: 30px;
  padding: 20px 0;
  position: fixed;
  bottom: 0;
}

.footer-bottom p {
  color: #ffffff;
  font-size: 12px;
  text-align: center;
  line-height: 39px;
}

.qrcode-box {
  position: fixed;
  bottom: 80px;
  display: flex;
  justify-content: center;
  width: 100%;

  > div {
    display: flex;
  }

  .code-item {
    text-align: center;
    font-size: 12px;
    color: white;

    &:last-child {
      margin-left: 20px;
    }

    img {
      width: 100px;
      height: 100px;
    }
  }
}
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.loading-text {
  margin-top: 100px;
  color: #fff;
  font-size: 16px;
  padding-left: 40px;
}
.chase {
  position: relative;
}
.chase:after,
.chase:before {
  content: "";
  height: 30px;
  width: 30px;
  display: block;
  -webkit-animation: out 0.5s backwards, spin 1.25s 0.5s infinite ease;
  animation: out 0.5s backwards, spin 1.25s 0.5s infinite ease;
  border: 5px solid #fff;
  border-radius: 100%;
  -webkit-box-shadow: 0 -40px 0 -5px #fff;
  box-shadow: 0 -40px 0 -5px #fff;
  position: absolute;
}
.chase:after {
  -webkit-animation-delay: 0s, 1.25s;
  animation-delay: 0s, 1.25s;
}

@-webkit-keyframes out {
  from {
    -webkit-box-shadow: 0 0 0 -5px #fff;
    box-shadow: 0 0 0 -5px #fff;
  }
}

@keyframes out {
  from {
    -webkit-box-shadow: 0 0 0 -5px #fff;
    box-shadow: 0 0 0 -5px #fff;
  }
}

@-webkit-keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
<style>
.code {
  text-align: center;
}

.code img {
  display: inline-block !important;
  width: 200px;
}

.download {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-weight: 800;
  width: 200px;
  height: 50px;
  background-color: #39baa0;
  border-radius: 10px;
}

.download:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/comm/views/Login4Workspace.vue